<template>
  <div class="doctorpc-memo">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="memo-box">
        <div class="memo-text" @scroll="doScroll" v-html="memoText">
          <!-- <div class="memo-content" ref="momeContent"></div> -->
        </div>
      </div>
      <div class="agree-box">
        <van-checkbox :value="checked" icon-size="16px" :checked-color="themeColor" @click="agreeClick">我已经仔细阅读并同意成为“择美同行-患者援助项目”的项目医生，并遵循项目规定。</van-checkbox>
      </div>
      <div class="docpc-form-btn">
        <div class="btn-item">
          <van-button :color="themeColor" block size="small" :disabled="second > 0" @click="next()">确认<template v-if="second>-1">（{{second}}秒）</template></van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@vant/touch-emulator' // 解决vant组件在pc端不支持touch事件
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import {
  configGetMemo, readMemo
} from '@/api/doctorapi';
import {
  Toast,
  Dialog,
} from "vant";
import {
  mapState,
  mapActions
} from "vuex";

export default {
  name: 'docpcMemo',
  components: {
    docpcSteps
  },
  data() {
    return {
      themeColor: this.themeColor,
      stepActive: 1,
      name: '',
      doctor_info: null,
      checked: false,
      memoText: ``,
      timeout: false,
      isBottom: false,
      timer:null,
      second: 5,
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.name = this.docpc.docpcInfo.doctor.name
    configGetMemo().then(res => {
      this.memoText = res.data.value.replace(/{name}/, this.name)
      this.timer = setInterval(() => {
        this.second--;
        if (this.second < 0) {
          clearInterval(this.timer);
          this.timeout = true
          console.log('this.timeout',this.timeout)
        }
      },1000)
    }).catch(err => {
        Toast(err.response.data.message)
    })
  },
  methods: {
    doScroll(e) {
      let scrollB = e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop
      if (scrollB<1) {
        this.isBottom = true
        console.log('this.isBottom',this.isBottom)
      }
    },
    agreeClick() {
      if (this.timeout) {
        this.checked = !this.checked
      } else {
        Toast('请阅读完医生理解备忘录后再进行勾选')
      }
    },
    next() {
      if(!this.checked) {
        Toast('请阅读完医生理解备忘录后再进行勾选')
        return
      }
      readMemo({
        params:{
          id:this.docpc.docpcInfo.doctor.id
        }
      }).then((res)=>{
        this.$router.replace({
          name: "docpcRecord",
        });
      })
    }
  }
}
</script>

<style lang='less'>
.doctorpc-memo {
  .van-popup--center {
    background: transparent;
  }
  .memo-box {
    position: relative;
    height: 360px;
    display: flex;
    flex-direction: column;

    .memo-title {
      background: #fff;
      box-sizing: content-box;
      width: auto;
      line-height: 24px;
      height: 24px;
      font-size: 1.6rem;
      text-align: center;
      padding: 20px 50px 10px;
    }

    .memo-text {
      flex: 1;
      height: 50%;
      font-size: 1.4rem;
      line-height: 1.5;
      height: 100%;
      padding: 15px;
      overflow-y: auto;
      transition: transform .3s;
      -webkit-overflow-scrolling: touch;
    }

    .memo-btn {
      position: absolute;
      left: 50%;
      bottom: -20px;
      margin-left: -50px;
      .van-button {
        width: 100px;
      }
    }
  }
  .agree-box {
    // height: 60px;
    line-height: 20px;
    padding: 20px;
    text-align: left !important;
    vertical-align: middle;
    .van-checkbox {
      // justify-content: center;
      align-items: flex-start;
    }
    .van-checkbox__icon {
      margin-top: 2px;
    }
  }
}
</style>